<template>
    <div class="modal-container">
        <el-dialog
            title="确认收货？"
            width="580px"
            custom-class="modal-wrap"
            :close-on-click-modal="false"
            :visible.sync="showModal"
            :before-close="onModal_close"
        >
            <div class="modal-inner">
                <div class="text-2">确认收货后，此售后服务单将完成。</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="btnFlexBox">
                    <div class="btn btn-ripple" @click="refund_receive">确定</div>
                    <div class="btn2 btn-ripple" @click="showModal = false">取消</div>
                </div>
            </span>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'modal-wuliu',
    components: {},
    props: [''],
    data() {
        return {
            showModal: false,
            company: '',
            code: '',
        }
    },
    computed: {
        ...mapState(['baseInfo']),
    },
    watch: {},

    mounted() {
        // this.creatQrCode();
    },

    methods: {
        init(refund_id) {
            this.showModal = true
            this.refund_id = refund_id
        },

        refund_receive() {
            this.$api('refund_qrShouHuo', {
                id: this.refund_id,
            }).then((res) => {
                let { code, data, msg } = res
                if (code == 200) {
                    // this.$emit("updateView");
                    this.$parent.setView()
                    this.showModal = false
                }
            })
        },

        onModal_close() {
            this.showModal = false
        },
    },
}
</script>

<style scoped lang="less">
.modal-wrap {
    .modal-inner {
        padding: 20px;

        .text-1 {
            font-weight: bold;
            font-size: 20px;
            color: #ff3d00;
        }
        .text-2 {
            text-align: center;
            font-size: 14px;
            color: #333333;
            margin-bottom: 20px;
        }
    }
}

/deep/ .el-dialog__header {
    height: 60px;
    border-bottom: 1px solid #eee;
    background: #f7f7f7;

    .el-dialog__title {
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        font-size: 26px;
        line-height: 26px;
        color: rgb(96, 108, 128);
    }
}

/deep/ .el-dialog__footer {
    text-align: center;

    .btnFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
            width: 104px;
            height: 40px;
            background: #ff4d00;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 14px;
            margin-right: 20px;
            cursor: pointer;
        }

        .btn2 {
            width: 104px;
            height: 40px;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #ff4d00;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #ff4d00;
            line-height: 14px;
            cursor: pointer;
        }
    }
}
</style>
